module.exports = __webpack_public_path__ + "static/media/Logo.9f9ec5f8.png";